import React from 'react'
import { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPlus,
  faUpload,
  faTrashAlt,
  faCirclePlus,
  faDownload,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons'
import SideBar from '../../SideBar'
import moment from 'moment';
import useAxiosPrivateSAI from '../../../hooks/useAxiosPrivateSAI'
import useAuth from '../../../hooks/useAuth'

const Holidays = () => {
  const axios = useAxiosPrivateSAI()
  const { createInfo } = useAuth()
  const [policyData, setPolicyData] = useState(null)
  const formatDate = (dateStr) => moment(dateStr).format('YYYY-MM-DD');
  const [holidays, setHolidays] = useState({});
  const [isDraft, setIsDraft] = useState(false);
  const [insetDays, setInsetDays] = useState([])
  const [orgType, setOrgType] = useState(null)
  const getAcademicYears = () => {
    const currentMonth = moment().month()
    const currentYear = moment().year()
    const startYear = currentMonth >= 8 ? currentYear : currentYear - 1

    return [
      `${startYear - 1}-${startYear}`,
      `${startYear}-${startYear + 1}`,
      `${startYear + 1}-${startYear + 2}`,
    ]
  }
  const academicYears = getAcademicYears()
  const [selectedYear, setSelectedYear] = useState(academicYears[1])
  const [isFetchingHolidays, setIsFetchingHolidays] = useState(false)
  const [isSubmittingHolidays, setIsSubmittingHolidays] = useState(false)
  const [isAutofillingLA, setIsAutofillingLA] = useState(false)
  const [insetRemovingById, setInsetRemovingById] = useState({})

  const holidayLabels = [
    { label: 'Autumn Half Term', key: 'autumn' },
    { label: 'Christmas Holiday', key: 'xmas' },
    { label: 'Spring Half Term', key: 'spring' },
    { label: 'Easter Holiday', key: 'easter' },
    { label: 'Summer Half Term', key: 'summerHalf' },
    { label: 'Summer Holiday', key: 'summer' },
  ]

  const fetchHolidays = async (orgType, academyId, year) => {
    setIsFetchingHolidays(true)
    try {
      const response = await axios.get(
        `/api/v1/staff-hub/holidays/ajax_get/${orgType}/${academyId}/${year}?api_token=${process.env.REACT_APP_KIS_TOKEN}`
      );
      const data = response.data;

      setHolidays({
        autumn: {
          start: formatDate(data.autumn?.start_date),
          end: formatDate(data.autumn?.end_date),
        },
        xmas: {
          start: formatDate(data.xmas?.start_date),
          end: formatDate(data.xmas?.end_date),
        },
        spring: {
          start: formatDate(data.spring?.start_date),
          end: formatDate(data.spring?.end_date),
        },
        easter: {
          start: formatDate(data.easter?.start_date),
          end: formatDate(data.easter?.end_date),
        },
        summerHalf: {
          start: formatDate(data.summerHalf?.start_date),
          end: formatDate(data.summerHalf?.end_date),
        },
        summer: {
          start: formatDate(data.summer?.start_date),
          end: formatDate(data.summer?.end_date),
        },
      });

      setInsetDays(data.inset || []);
    } catch (error) {
      console.error('Error fetching holidays:', error);
    } finally {
      setIsFetchingHolidays(false)
    }
  }

  useEffect(() => {
    const storedPolicy = JSON.parse(localStorage.getItem('policyData'))
    const storedOrg = JSON.parse(localStorage.getItem('orgType'))
    setPolicyData(storedPolicy)
    setOrgType(storedOrg)
  }, [])

  useEffect(() => {
    if (!policyData?.policy_id || !orgType?.type || !orgType?.id) return
    fetchHolidays(orgType.type, orgType.id, selectedYear)
  }, [selectedYear, policyData, orgType])

  const addInsetDay = async () => {
    try {
      const response = await axios.get(
        `/api/v1/staff-hub/holidays/inset_create/${orgType.type}/${orgType.id}/${selectedYear}?api_token=${process.env.REACT_APP_KIS_TOKEN}`
      );

      setInsetDays(prev => [
        ...prev,
        {
          id: response.data,
          description: '',
          start_date: '',
        },
      ]);
    } catch (error) {
      createInfo('error', 'Failed to create inset day');
    }
  };

  const handleHolidayChange = async (key, field, value) => {
    const updated = {
      ...holidays,
      [key]: {
        ...holidays[key],
        [field]: value,
      },
    };

    setHolidays(updated);
    console.log(orgType)
    try {
      await axios.post(
        `/api/v1/staff-hub/holidays/ajax_update/${orgType.type}/${orgType.id}?api_token=${process.env.REACT_APP_KIS_TOKEN}`,
        {
          start: field === 'start' ? value : updated[key].start,
          end: field === 'end' ? value : updated[key].end,
          tagName: key,
          year: selectedYear,
          holiday_status: 'draft',
        }
      );
      setIsDraft(true);
      createInfo('success', 'Holidays submitted successfully.')
    } catch (error) {
      createInfo('error', 'Failed to update holiday')
    }
  }


  const handleInsetChange = async (idx, field, value) => {
    const updated = [...insetDays];
    updated[idx][field] = value;
    setInsetDays(updated);

    const inset = updated[idx];

    try {
      await axios.post(`/api/v1/staff-hub/holidays/ajax_update/${orgType.type}/${orgType.id}?api_token=${process.env.REACT_APP_KIS_TOKEN}`, {
        id: inset.id || undefined,
        start: inset.start_date,
        description: inset.description,
        tagName: 'inset',
        year: selectedYear,
        holiday_status: 'draft',
      })

      setIsDraft(true);
    } catch (error) {
      createInfo('error', 'Failed to update inset day')
    }
  }

  const submitHolidays = async () => {
    setIsSubmittingHolidays(true)
    try {
      if (!orgType?.id) {
        console.warn("Organisation ID not found.");
        return;
      }

      const response = await axios.post(`/api/v1/staff-hub/holidays/submit?api_token=${process.env.REACT_APP_KIS_TOKEN}`, {
        ids: [orgType.id]
      });

      if (response.data?.error === false) {
        await fetchHolidays(orgType.type, orgType.id, selectedYear);
        setIsDraft(false)
        createInfo('success', 'Holidays submitted successfully.')
      } else {
        setIsDraft(true)
        createInfo('error', response.data?.message || 'Something went wrong.')
      }
    } catch (error) {
      setIsDraft(true)
      createInfo('error', 'Failed to submit holidays')
    } finally {
      setIsSubmittingHolidays(false)
    }
  }

  const removeInset = async (id) => {
    setInsetRemovingById(prev => ({ ...prev, [id]: true }))
    try {
      const response = await axios.post(
        `/api/v1/staff-hub/holidays/inset/${id}?api_token=${process.env.REACT_APP_KIS_TOKEN}`)

      createInfo('success', 'Inset day removed')
      return response.data;
    } catch (error) {
      createInfo('error', 'Failed to delete inset day')
      throw error;
    } finally {
      setInsetRemovingById(prev => ({ ...prev, [id]: false }))
    }
  }

  const resetHolidayStore = (schools) => {
    const ids = schools.map((school) => school.organization_id);

    axios
      .post(`/api/v1/staff-hub/holidays/reset?api_token=${process.env.REACT_APP_KIS_TOKEN}`, { ids })
      .then((response) => {
        if (response.data === 'draft') {
        } else if (response.data === 'error') {
          setTimeout(() => {
            createInfo('error', 'You have not committed any staff details yet')
          }, 500);
        } else if (!response.data.error) {
          window.location.reload()
        }

        setIsDraft(true);
      })
      .catch((error) => {
        console.error('Error resetting holiday store:', error);
      });
  }

  const mapHolidayNameToKey = (rawName = '') => {
    const name = rawName.toLowerCase().trim()

    // Half-terms
    if (name.includes('autumn') && name.includes('half')) return 'autumn'
    if (name.includes('spring') && name.includes('half')) return 'spring'
    if (name.includes('summer') && name.includes('half')) return 'summerHalf'

    // Full holidays
    if (name.includes('summer') && name.includes('holiday')) return 'summer'
    if (name.includes('spring') && name.includes('holiday')) return 'easter'
    if (name.includes('autumn') || name.includes('autumn')) return 'xmas'

    if (name === 'autumn holiday') return 'xmas'

    return null
  }

  const parseLARecordsToState = (records = [], year) => {
    const rows = records.filter(row => (row.academic_year || '').trim() === (year || '').trim())

    const next = {
      autumn: { start: '', end: '' },
      xmas: { start: '', end: '' },
      spring: { start: '', end: '' },
      easter: { start: '', end: '' },
      summerHalf: { start: '', end: '' },
      summer: { start: '', end: '' },
    }

    rows.forEach(row => {
      const key = mapHolidayNameToKey(row.holiday)
      if (!key) return
      next[key] = {
        start: moment(row.start_date).format('YYYY-MM-DD'),
        end: moment(row.end_date).format('YYYY-MM-DD'),
      }
    })

    return next
  }

  const applyLAHolidays = async (laRows) => {
    const next = parseLARecordsToState(laRows, selectedYear);
    setHolidays(next)
    setInsetDays([])
    setIsDraft(true)
  }

  const autofillLAHolidays = async () => {
    setIsAutofillingLA(true)
    try {
      const orgType = JSON.parse(localStorage.getItem('orgType'))

      if (!orgType?.type || !orgType?.id) {
        createInfo('error', 'Missing organisation details.')
        return;
      }
      const { data } = await axios.get(
        `/api/v1/staff-hub/holidays/get-la-holidays/${orgType.type}/${orgType.id}?api_token=${process.env.REACT_APP_KIS_TOKEN}`
      )


      const laHoliday = data?.data || [];
      if (!laHoliday || (Array.isArray(laHoliday) && laHoliday.length === 0)) {
        createInfo('error', 'No LA Holidays found for this borough.')
        return;
      }

      const filtered = laHoliday.filter(r => (r.academic_year || '').trim() === (selectedYear || '').trim())
      if (filtered.length === 0) {
        createInfo('error', `No LA holidays found for ${selectedYear}.`)
        return
      }

      await applyLAHolidays(laHoliday)
      createInfo('success', 'LA holidays applied.')

    } catch (error) {
      console.error('Could not fetch LA Holidays', error);
      createInfo('error', 'Failed to fetch LA Holidays. Please try again later.')
    } finally {
      setIsAutofillingLA(false);
    }
  }

  const isHolidayDataLoading = isFetchingHolidays || isSubmittingHolidays || isAutofillingLA

  return (
    <div className="w-full">
      <div className="flex flex-col lg:flex-row max-w-[90rem] mx-auto lg:space-x-6">
        <main className="w-full">
          <div className="flex items-center justify-end space-x-4">
            <button
              onClick={submitHolidays}
              disabled={isHolidayDataLoading}
              className="inline-flex items-center border border-white text-sas bg-white rounded-md overflow-hidden text-sm font-medium shadow"
            >
              <span className="px-4 py-2 inline-flex items-center gap-2">
                {isSubmittingHolidays ? (
                  <>
                    Loading...
                    <FontAwesomeIcon icon={faSpinner} spin />
                  </>
                ) : (
                  'Submit your Holidays'
                )}
              </span>
              <span className="bg-sas text-white px-3 py-2">
                <FontAwesomeIcon icon={faPlus} />
              </span>
            </button>
            <button onClick={autofillLAHolidays}
              disabled={isHolidayDataLoading}
              className="inline-flex items-center border border-white text-sas bg-white rounded-md overflow-hidden text-sm font-medium shadow">
              <span className="px-4 py-2 inline-flex items-center gap-2">
                {isAutofillingLA ? (
                  <>
                    Loading...
                    <FontAwesomeIcon icon={faSpinner} spin />
                  </>
                ) : (
                  'Autofull LA Holidays'
                )}
              </span>
              <span className="bg-sas text-white px-3 py-2">
                <FontAwesomeIcon icon={faDownload} />
              </span>
            </button>
          </div>
          {isFetchingHolidays && (
            <div className="flex justify-end items-center gap-2 text-sm text-sas mt-2">
              <span>Loading...</span>
              <FontAwesomeIcon icon={faSpinner} spin />
            </div>
          )}
          {isDraft ? (
            <div className='flex justify-end'>
              <div className="bg-orange-100 border border-orange-300 text-orange-800 px-4 py-2 rounded shadow text-sm my-4">
                Holidays have unsaved changes.
                <button onClick={() => resetHolidayStore(false)} className="underline font-semibold hover:text-orange-600">Revert Changes</button>
              </div>
            </div>
          ) : (
            null
          )}

          {/* Tabs */}
          <div className="flex space-x-2 mt-4">
            {academicYears.map((year) => (
              <button
                key={year}
                onClick={() => setSelectedYear(year)}
                disabled={isHolidayDataLoading}
                className={`px-4 py-2 rounded-t-md font-medium shadow-md border ${year === selectedYear
                  ? 'bg-sas text-white border-sas'
                  : 'bg-white text-gray-700 border-white'
                  }`}
              >
                {year}
              </button>
            ))}
          </div>

          {/* Holiday Form */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 m-0">
            {/* Left Column */}
            <div className="bg-white rounded-b-lg rounded-r-lg shadow-md p-6">
              <h4 className="font-semibold text-sas-dark mb-2 border-b pb-2">Holidays</h4>
              {holidayLabels.map(({ label, key }) => (
                <div key={key} className="mb-4">
                  <label className="block text-sm font-bold text-gray-700 mb-1">{label}</label>
                  <div className="grid grid-cols-2 gap-4">
                    <input
                      type="date"
                      value={holidays[key]?.start || ''}
                      onChange={(e) => handleHolidayChange(key, 'start', e.target.value)}
                      disabled={isHolidayDataLoading}
                      className="border border-sas rounded-md px-2 py-1 text-sm"
                    />
                    <input
                      type="date"
                      value={holidays[key]?.end || ''}
                      onChange={(e) => handleHolidayChange(key, 'end', e.target.value)}
                      disabled={isHolidayDataLoading}
                      className="border border-sas rounded-md px-2 py-1 text-sm"
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* Right Column */}
            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="flex justify-between items-center  mb-2 border-b pb-2">
                <h4 className="font-semibold text-sas-dark">Additional Days</h4>
                <button type="button"
                  onClick={addInsetDay}
                  disabled={isHolidayDataLoading}
                  className="inline-flex items-center border border-sas text-sas rounded-md overflow-hidden text-sm font-medium">
                  <span className="px-4 py-2">Add Inset Day</span>
                  <span className="bg-sas text-white px-3 py-2">
                    <FontAwesomeIcon icon={faPlus} />
                  </span>
                </button>
              </div>
              {insetDays.map((inset, idx) => (
                <div key={idx} className="flex items-center gap-2 mb-3">
                  <select
                    value={inset.description}
                    onChange={(e) =>
                      handleInsetChange(idx, 'description', e.target.value)
                    }
                    disabled={isHolidayDataLoading || insetRemovingById[inset.id] === true}
                    className="w-1/2 border  border-sas px-2 py-1 text-sm rounded h-8"
                  >
                    <option value="">Select Type</option>
                    <option value="Inset Day">Inset Day</option>
                    <option value="Religious Holiday">Religious Holiday</option>
                    <option value="Weather Closure">Weather Closure</option>
                    <option value="Other">Other</option>
                  </select>
                  <input
                    type="date"
                    value={inset.start_date}
                    onChange={(e) =>
                      handleInsetChange(idx, 'start_date', e.target.value)
                    }
                    disabled={isHolidayDataLoading || insetRemovingById[inset.id] === true}
                    className="w-1/2 border px-2 py-1 text-sm rounded border-sas"
                  />
                  <button
                    type="button"
                    onClick={() => removeInset(inset.id)}
                    disabled={isHolidayDataLoading || insetRemovingById[inset.id] === true}
                    className="text-red-500 disabled:text-gray-400 disabled:cursor-not-allowed"
                  >
                    {insetRemovingById[inset.id] === true ? (
                      <span className="inline-flex items-center gap-2 text-xs">
                        Loading...
                        <FontAwesomeIcon icon={faSpinner} spin />
                      </span>
                    ) : (
                      <FontAwesomeIcon icon={faTrashAlt} className="cursor-pointer" />
                    )}
                  </button>
                </div>
              ))}
              <div>
              </div>
            </div>

          </div>
        </main>
      </div>
    </div>
  )
}

export default Holidays
